// UI texts: report history (krug 3, U2)
export default {
  title: 'Past reports',
  sub: 'Your last {n} runs',
  emptyTitle: 'No reports yet',
  emptyBody: 'Send your survivor out. Every run leaves a report here.',
  toMap: 'Open the map',
  number: '#{n}',
  status: {
    active: 'Out there',
    awaiting: 'Out there',
    returned: 'Report ready',
  },
  outcome: {
    returned: 'Came back',
    full: 'Came back full',
    retreated: 'Turned back',
    robbed: 'Robbed',
    defeated: 'Knocked down',
  },
  kind: {
    horde: 'Horde wave',
    raid: 'Raid',
  },
  key: {
    ambush: 'Ambush',
    ambushed: 'Ambushed',
    pvp: 'Fight',
    item: 'Find',
    special: 'Find',
    escape: 'Escape',
    choice: 'Choice',
    trade: 'Trade',
    combat: 'Fight',
    horde_wave: 'Horde',
  },
  xp: '+{n} XP',
  hp: '−{n} HP',
  found: '{n} found',
  foundOne: '1 found',
} as const;
